import React, { useEffect, useState } from "react";
import { Card, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import apiFc from "../../services/APIFc";
import {
  formatearFechaLocal,
  formatearPrecio,
} from "../../functions/Procedimientos";

const PedidosRecibos = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true); // estado de carga

  useEffect(() => {
    const graphqlQuery = {
      query: `
        query {
          pedidoRecibosPorCliente {
            pedRecNro
            vendedorID
            pedRecFecha
            pedRecTotal
            pedRecEstadoSinc
          }
        }
      `,
    };

    apiFc
      .post("/graphql", graphqlQuery)
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error en la consulta GraphQL:", error);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <Row>
        <Col>
          <Card className="overflow-hidden">
            <Card.Header className="pb-1">
              <Card.Title className="mb-2">Pedidos Recibos</Card.Title>
            </Card.Header>
            <Card.Body className="p-0">
              <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  </div>
                ) : (
                  <ListGroup className="projects-list border-0">
                    {data.pedidoRecibosPorCliente &&
                    data.pedidoRecibosPorCliente.length > 0 ? (
                      data.pedidoRecibosPorCliente.map(
                        (reciboCliente: any, index: number) => (
                          <ListGroupItem
                            key={index}
                            className="list-group-item-action flex-column align-items-start border-bottom-0 border-start-0 border-end-0 border-top"
                          >
                            <div className="d-flex w-100 justify-content-between">
                              <p className="tx-13 mb-2 font-weight-semibold text-dark">
                                Recibo Nro: {reciboCliente.pedRecNro}
                              </p>
                              <h4 className="text-dark mb-0 font-weight-semibold tx-18">
                                {formatearPrecio({
                                  valor: reciboCliente.pedRecTotal,
                                })}
                              </h4>
                            </div>
                            <div className="d-flex w-100 justify-content-between">
                              <span className="text-muted tx-12">
                                {formatearFechaLocal(reciboCliente.pedRecFecha)}
                              </span>
                            </div>
                          </ListGroupItem>
                        )
                      )
                    ) : (
                      <ListGroupItem className="text-center text-muted py-4">
                        Sin recibos
                      </ListGroupItem>
                    )}
                  </ListGroup>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PedidosRecibos;
